export const styles = (theme) => ({
  tablePagination: {
    margin: 20,
    float: "right",
    opacity: 0.5,
  },
  errorText: {
    fontSize: 12,
    color: "#e30613",
  },
});
